import queryString from 'query-string'

onDomLoad(($dom) => {
  const dragHandleSelector = '[data-behaviour="workflow-status-drag-handle"]'

  const $reorderWrapper = $dom.find(
    '[data-behaviour="reorder-workflow-statuses-buttons"]'
  )
  const $reorderBtn = $dom.find('[data-behaviour="reorder-workflow-statuses"]')

  // onDomLoad runs scoped to each loaded turbo frame; only initialise when the
  // current scope actually contains the reorder controls, so a frame-load that
  // does not include them is a no-op rather than re-running sortable setup.
  if (!$reorderBtn.length) return

  const $sortableList = $dom.find(
    '[data-behaviour="workflow-statuses"] .workflow-statuses-list'
  )
  let $dragHandles = $dom.find(dragHandleSelector)

  const initialItemsHtml = $sortableList.html()

  const writeIdsToForm = () => {
    const idsAsQueryString = $sortableList.sortable('serialize')
    const idsInOrder = queryString.parse(idsAsQueryString)['workflow_status[]']
    $dom.find('[name="workflow_statuses[ids]"]').attr('value', idsInOrder)
  }

  // initialize the list as sortable, but disable it initially
  $sortableList.sortable({
    placeholder: 'workflow-status-placeholder',
    update: writeIdsToForm,
    handle: dragHandleSelector,
    tolerance: 'pointer',
  })
  $sortableList.sortable('disable')
  writeIdsToForm()

  const toggleReorderMode = () => {
    $reorderWrapper.toggleClass('sf-hidden')
    $reorderBtn.toggleClass('sf-hidden')
    $dragHandles.toggleClass('sf-hidden')
  }

  // on cancel, replace the HTML of the list with what was preserved on page load
  $dom
    .find('[data-behaviour="cancel-reorder-workflow-statuses"]')
    .on('click', () => {
      toggleReorderMode()
      $sortableList.sortable('disable')
      $sortableList.html(initialItemsHtml)
      $dragHandles = $dom.find(dragHandleSelector)
    })

  $dom
    .find('[data-behaviour="save-reorder-workflow-statuses"]')
    .on('click', () => {
      toggleReorderMode()
      $sortableList.sortable('disable')
    })

  $reorderBtn.on('click', () => {
    $sortableList.sortable('enable')
    toggleReorderMode()
  })

  document.addEventListener(
    'turbolinks:visit',
    () => {
      if (!$dragHandles.hasClass('sf-hidden')) {
        toggleReorderMode()
      }
    },
    { once: true }
  )
})
